<template>
  <div>
    <v-dialog
      v-model="openDialog"
      persistent
      :overlay="false"
      fullscreen
      transition="dialog-transition"
    >
      <div class="bg-black p-4">
        <div class="md:w-1/2 px-4 py-2 space-y-1">
          <!-- <pre>
            {{ notification_history }}
          </pre> -->
          <v-card color="#D6DCE5">
            <!-- Existing progress bar for other operations, e.g., watchlist update -->
            <v-progress-linear
              color="green"
              :indeterminate="indeterminate"
              rounded
              height="10"
            ></v-progress-linear>
            <div>
              <v-btn @click="close" small text>
                <v-icon small>mdi-close</v-icon>
              </v-btn>
            </div>

            <div class="py-4 px-10">
              <div class="flex items-center justify-between">
                <div :class="boxStyleTitle">
                  Ticket Information
                </div>
                <div
                  :class="boxStyleTitle"
                  v-if="$route.meta.title == 'Open Tickets'"
                >
                  <v-switch
                    v-model="watch_list"
                    color="primary"
                    :label="'Watchlist: ' + (watch_list ? 'Active' : 'Off')"
                    hide-details
                  ></v-switch>
                </div>
              </div>
              <div v-if="classification_id == 7">
                <div
                  class="grid grid-cols-3 my-1"
                  v-for="(item, i) in tabs"
                  :key="i"
                >
                  <div class="bg-gray-200 px-2">
                    {{ item.label }}
                  </div>
                  <div class="col-span-2 border-gray-300 border">
                    <input
                      readonly
                      type="text"
                      v-model="item.value"
                      class="w-full px-2"
                    />
                  </div>
                </div>
              </div>
              <div v-if="csvInfo.length > 0">
                <table class="bg-white w-full">
                  <tr>
                    <td :class="td_style">
                      Ticket Number:
                    </td>
                    <td :class="td_style">
                      {{ selectedItemInfo.moldex_ticket_number }}
                    </td>
                  </tr>
                  <tr>
                    <td :class="td_style">
                      Contract Number:
                    </td>
                    <td :class="td_style">
                      {{ csvInfo[0].contract_number }}
                    </td>
                  </tr>
                  <tr>
                    <td :class="td_style">
                      Buyer:
                    </td>
                    <td :class="td_style">
                      {{ csvInfo[0].buyer_name }}
                    </td>
                  </tr>
                  <tr>
                    <td :class="td_style">
                      Project:
                    </td>
                    <td :class="td_style">
                      {{ csvInfo[0].project }}
                    </td>
                  </tr>
                  <tr>
                    <td :class="td_style">
                      Building
                    </td>
                    <td :class="td_style">
                      {{ csvInfo[0].building }}
                    </td>
                  </tr>
                  <tr>
                    <td :class="td_style">
                      Phase
                    </td>
                    <td :class="td_style">
                      {{ csvInfo[0].phase }}
                    </td>
                  </tr>
                  <tr>
                    <td :class="td_style">
                      Block
                    </td>
                    <td :class="td_style">
                      {{ csvInfo[0].block }}
                    </td>
                  </tr>
                  <tr>
                    <td :class="td_style">
                      Lot
                    </td>
                    <td :class="td_style">
                      {{ csvInfo[0].lot }}
                    </td>
                  </tr>
                  <tr>
                    <td :class="td_style">
                      Email Address
                    </td>
                    <td :class="td_style">
                      {{ selectedItemInfo.email }}
                    </td>
                  </tr>
                  <tr>
                    <td :class="td_style">
                      Classification
                    </td>
                    <td :class="td_style">
                      {{ selectedItemInfo.classification }}
                    </td>
                  </tr>
                  <tr>
                    <td :class="td_style">
                      To:
                    </td>
                    <td :class="td_style">
                      {{ selectedItemInfo.email }}
                    </td>
                  </tr>
                  <tr>
                    <td :class="td_style">
                      Subject:
                    </td>
                    <td :class="td_style">
                      {{ selectedItemInfo.subject }}
                    </td>
                  </tr>
                  <tr>
                    <td :class="td_style">
                      Status
                    </td>
                    <td :class="td_style">
                      {{ selectedItemInfo.status_type }}
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </v-card>
          <v-card color="#D6DCE5" class="p-10">
            <div :class="boxStyleTitle">Communication Logs</div>
            <!-- history here  -->
            <div class="p-10 bg-white">
              <ul class="list-disc">
                <div v-for="(item, i) in notification_history" :key="i">
                  <li @click="open_history_email(item)">
                    {{ item.kaction }} on {{ formatPhDateTime(item.reg_date) }}
                  </li>
                </div>
              </ul>
            </div>
          </v-card>
        </div>
        <!-- Right Side Fixed email box  -->
        <div
          class="
            bg-[#D6DCE5]
            flex flex-col
            md:fixed
            rounded
            p-10
            top-0
            bg-white
            h-[100vh]
            right-0
            md:w-1/2
            overflow-y-scroll
          "
        >
          <div class="text-[16px] font-black py-2">Email</div>

          <div>
            <div
              class="flex items-center border-2 border-solid border-gray-600"
            >
              <div class="w-[100px] bg-gray-300">
                <div class="p-2">Subject</div>
              </div>
              <div class="w-full">
                <input
                  class="w-full p-2 bg-white border-l-2 border-solid border-gray-500"
                  type="text"
                  v-model="emailed_subject"
                />
              </div>
            </div>
            <div class="border-2 border-gray-800">
              <!-- Text Editor -->
              <div class="email-content">
                <vue-editor
                  v-model="textAreaEmail"
                  class="bg-white editor-height"
                ></vue-editor>
              </div>
            </div>
          </div>
          <div class="mb-4">
            <div class="flex items-center align-middle space-x-4">
              <button
                class="my-2 px-4 py-2 rounded-md shadow-md w-[200px] bg-white"
                @click="upload_attachment"
              >
                <span class="text-[14px]">
                  {{
                    attachments.length > 0
                      ? `${attachments.length} attachments`
                      : "Attach file/s"
                  }}
                </span>
              </button>
              <div class="text-xs" v-if="attachments.length > 0">
                Total file size:
                {{ (totalAttachmentSize / 1024).toFixed(2) }} KB
              </div>
            </div>
            <input
              type="file"
              ref="attachmentInput"
              @change="on_attachment_uploaded"
              style="display: none"
            />
            <div v-if="attachments.length > 0">
              <!-- List of attachment file names -->
              <ul class="text-xs list-disc w-full space-y-1">
                <li
                  v-for="(file, index) in attachments"
                  :key="index"
                  class="px-1"
                >
                  {{ file.name }} / ({{ (file.size / 1024).toFixed(2) }} KB)
                  <button @click="removeOneAttachment(index)">
                    <v-icon small>mdi-close</v-icon>
                  </button>
                </li>
              </ul>
            </div>
          </div>

          <!-- New Progress Bar (shows during email sending) -->
          <div v-if="isUploading || uploadProgress > 0" class="mb-4">
            <v-progress-linear
              :value="uploadProgress"
              color="green"
              height="10"
              rounded
            ></v-progress-linear>
            <div class="text-xs mt-1 text-right" style="color: #000;">
              {{ uploadProgress.toFixed(2) }}%
            </div>
          </div>

          <div>
            <div class="w-full flex justify-center items-center space-x-4">
              <button
                class="px-4 py-2 rounded-md shadow-lg w-[200px] bg-white"
                @click="close"
              >
                Cancel
              </button>
              <button
                class="px-4 py-2 text-white rounded-md shadow-lg bg-[#2F5597] w-[200px]"
                @click="sendEmail"
              >
                Send Email
              </button>
            </div>
          </div>
        </div>
      </div>
    </v-dialog>
    <!-- email content history -->
    <v-dialog
      v-model="open_email_history_content"
      persistent
      :overlay="false"
      max-width="500px"
      transition="dialog-transition"
    >
      <div class="bg-white p-2">
        <v-btn @click="open_email_history_content = false" text small>
          <v-icon small>mdi-close</v-icon>
        </v-btn>
        <div class="p-2 bg-white rounded-md">
          <EmailContent :selected_email_row="selected_email_row" />
        </div>
      </div>
    </v-dialog>
    <!-- Status Dialog -->
    <v-dialog
      v-model="showStatusDialog"
      persistent
      :overlay="false"
      max-width="400px"
      transition="dialog-transition"
    >
      <v-card>
        <v-card-title class="headline">Message</v-card-title>
        <v-card-text>{{ statusDialogMessage }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="showStatusDialog = false"
            >OK</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { VueEditor } from "vue2-editor";
import axios from "axios";
import { formatPhDateTime } from "@/utils/formatPhDateTime";
// import moment from "moment";
import EmailContent from "./EmailContent.vue";
export default {
  data() {
    return {
      watch_list: false,
      initialLoad: true,
      td_style:
        "px-2 py-1 text-left bg-gray-100 border-solid border border-gray-500",
      boxStyleTitle: "text-[16px] font-calibri font-bold my-2",
      maxLimit: "",
      indeterminate: false,
      tableClass:
        "p-1 font-calibri border-solid border-2 border-gray-400 text-[14px]",
      openDialog: false,
      buyer_name: null,
      principal_first_name: null,
      principal_last_name: null,
      co_firstname: null,
      project: null,
      property: null,
      subject: null,
      request: null,

      contract_number: null,
      customer_code: null,
      email: null,
      mobile: null,
      ticket_number: null,

      tabs: [
        { id: 14, label: "Ticket Number", value: "ticket_number" },
        { id: 1, label: "Buyers Name", value: "buyer_name" },
        {
          id: 14,
          label: "Principal First Name",
          value: "principal_first_name",
        },
        { id: 15, label: "Principal Last Name", value: "principal_first_name" },
        { id: 11, label: "Co Borrower First Name", value: "co_firstname" },
        { id: 12, label: "Co Borrower Last Name", value: "co_lastname" },
        { id: 31, label: "Project Name", value: "project" },
        { id: 3, label: "Property Details", value: "property" },
        { id: 4, label: "Subject", value: "subject" },
        { id: 5, label: "Request", value: "request" },
        { id: 6, label: "Progress", value: "progress" },
        { id: 7, label: "Contract Number", value: "contract_number" },
        { id: 8, label: "Customer Code", value: "customer_code" },
        { id: 9, label: "Status", value: "status" },
        { id: 10, label: "Internal Status", value: "internal_status" },
        { id: 11, label: "Department", value: "department" },
        { id: 12, label: "Email", value: "email" },
        { id: 13, label: "Mobile", value: "mobile" },
      ],
      open_email_history_content: false,

      textarea: [],
      buyername: "",
      lastname: "",
      firstname: "",
      co_lastname: "",
      progress: [],
      status: "",
      internal_status: "",
      department: "",
      notification: "",
      internalNote: "",
      textAreaEmail: "",
      emailed_subject: "",
      ticket_id: "",
      selected_email_row: [],
      attachments: [],
      officialEmail: "",
      isUploading: false,
      uploadProgress: 0,
      uploadStatus: "",
      uploadSpeed: "",
      uploadedSize: 0,
      totalSize: 0,
      lastUploadedSize: 0,
      lastUploadTime: Date.now(),
      showStatusDialog: false,
      statusDialogMessage: "",
    };
  },
  computed: {
    switchLabel() {
      return this.watch_list ? "Watchlist: Active" : "Watchlist: Off";
    },
    totalAttachmentSize() {
      return this.attachments.reduce((total, file) => total + file.size, 0);
    },
  },
  components: { EmailContent, VueEditor },
  watch: {
    selectedItemInfo: {
      async handler(e) {
        if (e && Object.keys(e).length > 0) {
          this.watch_list = e.watchlist;
          this.officialEmail = e.email;
          this.openDialog = true;
          this.initialLoad = true;
          await this.getMaxLimit();
          this.initialLoad = false;
        }
      },
      immediate: true,
    },
    watch_list(newVal, oldVal) {
      if (!this.initialLoad && newVal !== oldVal) {
        this.updateWatchlistStatus();
      }
    },
  },
  props: [
    "showDialog",
    "selectedItemInfo",
    "notification_history",
    "csvInfo",
    "classification_id",
  ],
  methods: {
    addEmailHistory(action, ticket, user_id, subject, content) {
      const data = new FormData();
      data.append("action", action);
      data.append("ticket_id", ticket);
      data.append("user_id", user_id);
      data.append("subject", subject);
      data.append("content", content);
      if (this.attachments) {
        this.attachments.forEach((att) => {
          data.append("attachments", att);
        });
      }
      if (this.lastEmailAttachments) {
        data.append(
          "emailAttachmentPaths",
          JSON.stringify(this.lastEmailAttachments)
        );
      }
      axios.post("/history/add", data).then((res) => {
        if (res.status) {
          this.indeterminate = false;
          this.showStatusDialog = true;
          this.statusDialogMessage = "Your email was sent successfully!";
          setTimeout(() => {
            this.close();
          }, 500);
          location.reload();
        }
      });
    },

    async sendEmail() {
      this.indeterminate = true;
      this.isUploading = true;
      this.uploadProgress = 0;
      this.uploadStatus = "Preparing...";
      this.lastUploadTime = Date.now();
      let errorOccurred = false; // Flag to track if an error happens

      try {
        if (this.textAreaEmail.length === 0) {
          this.showStatusDialog = true;
          this.statusDialogMessage =
            "You did not write anything. Please don't leave it blank!";
          // End progress immediately if email text is missing
          return;
        }

        const data = new FormData();
        data.append("to", this.officialEmail);
        data.append("from", "Moldex Customer Service (donotreply)");
        data.append("subject", this.emailed_subject);
        data.append("html", this.textAreaEmail);
        this.attachments.forEach((att) => data.append("attachments", att));

        const response = await axios({
          method: "post",
          url: "/tickets/email_notification",
          data: data,
          onUploadProgress: (progressEvent) => {
            this.uploadedSize = progressEvent.loaded;
            this.totalSize = progressEvent.total;
            this.uploadProgress =
              (progressEvent.loaded * 100) / progressEvent.total;
            this.uploadStatus =
              this.uploadProgress < 90 ? "Uploading..." : "Sending email...";
            this.uploadSpeed = this.calculateSpeed(progressEvent.loaded);
          },
        });

        if (response.data.status) {
          const historyData = new FormData();
          historyData.append("action", "Email was sent. Thank you!");
          historyData.append("ticket_id", this.selectedItemInfo.ticket_id);
          historyData.append("user_id", 1);
          historyData.append("subject", this.emailed_subject);
          historyData.append("content", this.textAreaEmail);
          historyData.append(
            "processedFiles",
            JSON.stringify(response.data.processedFiles)
          );
          await axios.post("/history/add", historyData);
          this.showStatusDialog = true;
          this.statusDialogMessage = "Your email was sent successfully!";
          setTimeout(() => {
            this.close();
          }, 500);
          location.reload();
        } else {
          throw new Error("Email sending failed");
        }
      } catch (error) {
        console.error("Error:", error);
        this.uploadStatus = "Upload failed";
        this.showStatusDialog = true;
        this.statusDialogMessage = "Error sending email. Please try again.";
        errorOccurred = true;
      } finally {
        this.endProgressBar(errorOccurred);
      }
    },
    endProgressBar(errorOccurred = false) {
      this.indeterminate = false;
      this.isUploading = false;
      if (errorOccurred) {
        // Immediately reset progress on error
        this.uploadProgress = 0;
      } else {
        // Briefly show 100% before resetting on success
        this.uploadProgress = 100;
        setTimeout(() => {
          this.uploadProgress = 0;
        }, 500);
      }
      this.uploadStatus = "";
    },
    async updateWatchlistStatus() {
      try {
        this.indeterminate = true;
        const response = await axios.post("/tickets/update-watchlist", {
          watch_list: this.watch_list,
          ticket_id: this.selectedItemInfo.ticket_id,
        });
        if (response.status === 200) {
          this.indeterminate = false;
          this.statusDialogMessage = "Watchlist status updated successfully.";
          this.showStatusDialog = true;
        } else {
          throw new Error("Failed to update.");
        }
      } catch (error) {
        this.indeterminate = false;
        this.statusDialogMessage =
          "Error updating watchlist status: " + error.message;
        this.showStatusDialog = true;
      }
    },
    async getMaxLimit() {
      const output = await axios.get("/email/max_limit");
      this.maxLimit = output.data[0].size;
    },
    getAttachmentObjectUrl(a) {
      return URL.createObjectURL(a);
    },
    open_history_email(item) {
      this.open_email_history_content = true;
      this.selected_email_row = item;
    },
    upload_attachment() {
      this.statusDialogMessage = `Select file to upload - max file size = ${parseInt(
        this.maxLimit
      ) / 1000000}MB only`;
      this.showStatusDialog = true;
      this.$refs?.attachmentInput?.click();
    },
    on_attachment_uploaded(e) {
      const files = e.target.files;
      if (!e.target.files?.length) {
        return;
      } else {
        const selectedFile = files[0];
        const fileSize = selectedFile.size;
        if (fileSize > parseInt(this.maxLimit)) {
          return alert(
            `Select file to upload - max file size = ${parseInt(this.maxLimit) /
              1000000}MB only`
          );
        } else {
          this.attachments.push(selectedFile);
        }
      }
    },
    formatPhDateTime,
    removeOneAttachment(index) {
      this.attachments.splice(index, 1);
    },
    clear_data() {
      this.email = "";
      this.emailed_subject = "";
      this.textAreaEmail = "";
    },
    close() {
      this.openDialog = false;
      this.$emit("closeDialog");
      this.clear_data();
    },
    formatBytes(bytes) {
      if (!bytes) return "0 B";
      const k = 1024;
      const sizes = ["B", "KB", "MB", "GB"];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return `${parseFloat((bytes / Math.pow(k, i)).toFixed(2))} ${sizes[i]}`;
    },
    calculateSpeed(loaded) {
      const now = Date.now();
      const timeElapsed = (now - this.lastUploadTime) / 1000;
      const bytesPerSecond = (loaded - this.lastUploadedSize) / timeElapsed;
      this.lastUploadedSize = loaded;
      this.lastUploadTime = now;
      if (bytesPerSecond < 1024) return `${bytesPerSecond.toFixed(1)} B/s`;
      if (bytesPerSecond < 1048576)
        return `${(bytesPerSecond / 1024).toFixed(1)} KB/s`;
      return `${(bytesPerSecond / 1048576).toFixed(1)} MB/s`;
    },
    standardizeAndConvertToPH(reg_date) {
      // First standardize the date to a consistent format
      let date = new Date(reg_date);
      
      // Check if it's a valid date
      if (isNaN(date.getTime())) {
          return null; // or handle invalid date as needed
      }

      // Add 8 hours for Philippines time
      date.setHours(date.getHours() + 8);
      
      // Return formatted date and hour
      return {
          phDate: date,
          hour: date.getHours(), // 0-23
          // You can also get formatted string if needed
          formattedDate: date.toISOString()
      };
    }
  },
};
</script>

<style>
.email-content p {
  line-height: 1;
  margin: 0;
}
.email-content .editor-height {
  min-height: 480px;
  max-height: 480px;
  overflow-y: auto;
}
.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@keyframes pulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}
</style>
